import DataLoader from 'dataloader'
import { renderCode } from './render-code.js'
import { injectHtml } from './inject-html.js'

const widgetLoader = new DataLoader(
  async (widgetNames) => {
    const injectionTemplate = document.createElement('template')
    document.body.append(injectionTemplate)
    const injectionCode = Array.from(new Set(widgetNames))
      .map((widgetName) => `<${widgetName}></${widgetName}>`)
      .join('')
    const html = await renderCode(injectionCode)
    await injectHtml(injectionTemplate.content, html)
    return widgetNames.map(() => null)
  },
  {
    cache: true
  }
)

export async function installWidget(widgetName: string) {
  // if (WidgetElement.widgets.has(widgetName)) return
  await widgetLoader.load(widgetName)
}
